import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import LetsTalkStrategy from "./sections/LetsTalkStrategy";
import WeAreHereForYou from "./sections/WeAreHereForYou";
import FooterHub from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <LetsTalkStrategy />
      <WeAreHereForYou />
      <FooterHub />
    </div>;
}